import { useState } from 'react';
import { ArrowLeft, ArrowRight, Landmark, Plus } from 'lucide-react';
import BankProgram from './BankProgram';

// Add new programs here: each gets a card in the library and its own page.
const PROGRAMS = [
  {
    id: 'bank',
    name: 'Oceans Bank',
    tagline: 'Fake banking terminal with vault keys, transfer puzzle and live hints',
    icon: Landmark,
    accent: 'emerald',
    tags: ['Offline file', 'EN / JA', '3 themes'],
    Page: BankProgram,
  },
];

const ACCENTS = {
  emerald: 'border-emerald-500/40 hover:border-emerald-400 text-emerald-400 from-emerald-950/50',
};

function ProgramCard({ p, onOpen }) {
  return (
    <button type="button" onClick={onOpen} data-testid={`program-card-${p.id}`}
      className={`group text-left rounded-xl border-2 bg-gradient-to-br via-black to-neutral-950 p-5 transition-[transform,border-color] duration-200 hover:-translate-y-1 ${ACCENTS[p.accent]}`}>
      <p.icon size={30} />
      <h3 className="font-heading text-lg tracking-wider uppercase text-foreground mt-3">{p.name}</h3>
      <p className="text-xs text-muted-foreground mt-1 min-h-[32px]">{p.tagline}</p>
      <div className="flex flex-wrap gap-1.5 mt-3">
        {p.tags.map(t => <span key={t} className="text-[10px] font-mono border border-border rounded-full px-2 py-0.5 text-muted-foreground">{t}</span>)}
      </div>
      <span className="inline-flex items-center gap-1 mt-4 font-heading text-[11px] tracking-widest uppercase">
        Open <ArrowRight size={12} className="transition-transform group-hover:translate-x-1" />
      </span>
    </button>
  );
}

export default function ProgramsHub() {
  const [openId, setOpenId] = useState(null);
  const open = PROGRAMS.find(p => p.id === openId);

  if (open) {
    return (
      <div data-testid={`program-page-${open.id}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-6">
          <button type="button" onClick={() => setOpenId(null)} data-testid="programs-back"
            className="inline-flex items-center gap-2 font-heading text-xs tracking-widest uppercase text-muted-foreground hover:text-foreground">
            <ArrowLeft size={14} /> All Programs
          </button>
        </div>
        <open.Page />
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8" data-testid="programs-hub">
      <h2 className="font-heading text-2xl tracking-wider uppercase">Programs</h2>
      <p className="text-sm text-muted-foreground mt-1">Escape room programs you can download and run on the room computers.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        {PROGRAMS.map(p => <ProgramCard key={p.id} p={p} onOpen={() => setOpenId(p.id)} />)}
        <div data-testid="program-card-coming-soon"
          className="rounded-xl border-2 border-dashed border-border p-5 flex flex-col items-center justify-center text-center text-muted-foreground min-h-[200px]">
          <Plus size={26} />
          <span className="font-heading text-xs tracking-widest uppercase mt-2">More programs coming</span>
          <span className="text-[11px] mt-1">New programs you design will show up here.</span>
        </div>
      </div>
    </div>
  );
}
